let stripeInstance = null;

const PaymentMethodDetector = {
  detectPaymentMethods: async (forceLoad = false) => {
    try {
      // Skip loading if not on a payment-related page and not forced
      if (!forceLoad && typeof window !== 'undefined') {
        const currentPath = window.location.pathname;
        const paymentPages = ['/checkout', '/order-summary', '/buy', '/cart', '/profile/payment-details'];
        const shouldLoad = paymentPages.some(page =>
          currentPath.startsWith(page) || currentPath.includes(page)
        );

        if (!shouldLoad) {
          //console.log('Skipping Stripe load - not on payment page:', currentPath);
          return {
            googlePay: false,
            applePay: false,
            bothAvailable: false,
            anyAvailable: false,
            skipped: true,
            error: 'Stripe loading skipped - not on payment page'
          };
        }
      }

      // Lazy load Stripe only when needed
      if (!stripeInstance) {
        //console.log('Loading Stripe for payment detection...');
        const { loadStripe } = await import("@stripe/stripe-js");
        stripeInstance = await loadStripe(
          process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
        );
      }

      const stripe = stripeInstance;

      if (!stripe) {
        return {
          googlePay: false,
          applePay: false,
          bothAvailable: false,
          error: "Failed to load Stripe or invalid publishable key",
        };
      }

      // Create a minimal payment request to test availability
      const paymentRequest = stripe.paymentRequest({
        country: "US",
        currency: "usd",
        total: {
          label: "Payment Test",
          amount: 100, // $1.00 in cents
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      const result = await paymentRequest.canMakePayment();

      const googlePayAvailable = !!(result && result.googlePay);
      const applePayAvailable = !!(result && result.applePay);

      return {
        googlePay: googlePayAvailable,
        applePay: applePayAvailable,
        bothAvailable: googlePayAvailable && applePayAvailable,
        anyAvailable: googlePayAvailable || applePayAvailable,
        paymentRequest: result ? paymentRequest : null,
      };
    } catch (error) {
      console.error("Error detecting payment methods:", error);
      return {
        googlePay: false,
        applePay: false,
        bothAvailable: false,
        anyAvailable: false,
        paymentRequest: null,
        error: error.message,
      };
    }
  },

  // Method to clear Stripe instance when not needed
  clearStripeInstance: () => {
    //console.log('Clearing Stripe instance to free memory');
    stripeInstance = null;
  },

  // Check if Stripe is currently loaded
  isStripeLoaded: () => {
    return !!stripeInstance;
  }
};

export default PaymentMethodDetector;
